goog.provide('el8.uiwidget.base');
// This is the el8_datePicker... should get refactored out
goog.provide('el8.uiwidget.Datepicker');

goog.require('el8.util.datecompare');
goog.require('el8.util.consts');
goog.require('el8.uiwidget.alert');
goog.require('el8.service.infoField');

/**
 * This is a legacy file. It used to contain most of our uiwidgets,
 * but now it just has this sad el8_datePicker in it.
 * TODO el8_datePicker is also deprecated and should be replaced
 * with el8.uiwidget.addDatepicker
 */

(function($) {

    /**
    * Helper function to initialize custom datepicker field
    * @params {Object} opts
    * @params {Object} ifOpts -- options for InfoFieldWidget
    * @returns {Object} Returns InfoFieldWidget
    */
    $.fn.el8_datePicker = function( opts, ifOpts ) {

        opts = opts || {};
        var $elt = $(this);
        var dateSelectedFn = opts.dateSelectedFn || null;
        var closeFn = opts.closeFn || null;
        var defaultDate = opts.defaultDate || null;
        var $input = null;

        var isInput = $elt.is('input,textarea');
        var widget;

        if (isInput) {
            $input = $(this);
            ifOpts = ifOpts || {};
            ifOpts.field = $elt; // always true
            ifOpts.maxLength = ifOpts.maxLength || 20;
            ifOpts.infoText = ifOpts.infoText || 'e.g. ' + Date.format;
            widget = el8.service.infoField.addInfoField(ifOpts);
            if (defaultDate) { widget.setVal(defaultDate); }
        } else {
            $input = $('<input>'); // XSS OK -KF
            $input.insertAfter($elt).outerWidth(0).prop('disabled', true);
        }

        $input.datepicker({ buttonImage: '/static/images/calendar_16x15.png',
                           buttonImageOnly : true,
                           showOn: 'button',
                           onSelect: dateSelectedFn,
                           onClose: closeFn,
                           maxDate: opts.maxDate || null,
                           minDate: opts.minDate || el8.util.consts.MIN_DATE,
                           defaultDate: defaultDate,
                           constrainInput : false
                         });

        if (isInput) {
            $input.blur(function() {
                if (!widget.noInput()) {
                    var dateVal = el8.util.datecompare.processDateInput(widget.getVal(), null, el8.uiwidget.alert);
                    widget.setVal(dateVal ? dateVal.asString() : '');
                    if (dateSelectedFn) { dateSelectedFn(); }
                }
            }).click(function() {
                $input.datepicker("hide");
            // Overridding browser's autocomplete for previous entries
            }).attr('autocomplete', 'off');
        }

        return widget;
    };

})(jQuery);
